export const PENDING_APPROVAL_START_EDITING_INVESTMENT_MINIMUMS = 'PENDING_APPROVAL_START_EDITING_INVESTMENT_MINIMUMS'
export const PENDING_APPROVAL_STOP_EDITING_INVESTMENT_MINIMUMS = 'PENDING_APPROVAL_STOP_EDITING_INVESTMENT_MINIMUMS'
export const PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_LUMP_SUM = 'PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_LUMP_SUM'
export const PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_MONTHLY_DEBIT_ORDER = 'PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_MONTHLY_DEBIT_ORDER'
export const PENDING_APPROVAL_SET_ALLOW_UNSURE_INVESTORS = 'PENDING_APPROVAL_SET_ALLOW_UNSURE_INVESTORS'
export const PENDING_APPROVAL_CANCEL_EDITING_INVESTMENT_MINIMUMS = 'PENDING_APPROVAL_CANCEL_EDITING_INVESTMENT_MINIMUMS'
export const PENDING_APPROVAL_UPDATING_INVESTMENT_MINIMUMS = 'PENDING_APPROVAL_UPDATING_INVESTMENT_MINIMUMS'
export const PENDING_APPROVAL_UPDATED_INVESTMENT_MINIMUMS = 'PENDING_APPROVAL_UPDATING_INVESTMENT_MINIMUMS'

export const startEditingInvestmentMinimums = () => ({
  type: PENDING_APPROVAL_START_EDITING_INVESTMENT_MINIMUMS
})

export const stopEditingInvestmentMinimums = (INVESTMENT_MINIMUMS) => ({
  type: PENDING_APPROVAL_STOP_EDITING_INVESTMENT_MINIMUMS
})

export const setMinimumLumpSum = (minimumLumpSum) => ({
  type: PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_LUMP_SUM,
  minimumLumpSum
})

export const setMinimumMonthlyDebitOrder = (minimumMonthlyDebitOrder) => ({
  type: PENDING_APPROVAL_SET_INVESTMENT_MINIMUMS_MINIMUM_MONTHLY_DEBIT_ORDER,
  minimumMonthlyDebitOrder
})

export const setAllowUnsureInvestors = (allow) => ({
  type: PENDING_APPROVAL_SET_ALLOW_UNSURE_INVESTORS,
  allow
})

export const cancelEditingAdviserProfileInvestmentMinimums = () => ({
  type: PENDING_APPROVAL_CANCEL_EDITING_INVESTMENT_MINIMUMS
})
